document.addEventListener('DOMContentLoaded', () => {
    // Accordion Logic
    const triggers = document.querySelectorAll('.acc-trigger');
    triggers.forEach(trigger => {
        trigger.addEventListener('click', function() {
            const body = this.nextElementSibling;
            const icon = this.querySelector('.acc-icon');
            const isOpen = body.classList.contains('open');
            
            document.querySelectorAll('.acc-body.open').forEach(el => {
                el.classList.remove('open');
                el.previousElementSibling.querySelector('.acc-icon').classList.remove('open');
            });
            
            if (!isOpen) {
                body.classList.add('open');
                icon.classList.add('open');
            }
        });
    });

    // Intersection Observer for Fade Ins
    const io = new IntersectionObserver((entries) => {
        entries.forEach((entry, i) => {
            if (entry.isIntersecting) {
                setTimeout(() => entry.target.classList.add('visible'), i * 60);
                io.unobserve(entry.target);
            }
        });
    }, { threshold: 0.08 });

    document.querySelectorAll('.fade-in').forEach(el => io.observe(el));
});